import script from "./SplashArea.vue?vue&type=script&setup=true&lang=js"
export * from "./SplashArea.vue?vue&type=script&setup=true&lang=js"

import "./SplashArea.vue?vue&type=style&index=0&id=ab1b4b18&scoped=true&lang=scss"
import "./SplashArea.vue?vue&type=style&index=1&id=ab1b4b18&scoped=true&lang=css"
import "./SplashArea.vue?vue&type=style&index=2&id=ab1b4b18&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab1b4b18"]])

export default __exports__